import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import CompleteProfilePage from '../pages/CompleteProfile';
import ConfimEmailPage from '../pages/ConfirmEmail';
import ForgotPasswordPage from '../pages/ForgotPassword';
import ResetPasswordPage from '../pages/ResetPassword';
import SigninPage from '../pages/SignIn';
import SignupPage from '../pages/SignUp';

export function PublicRoutes() {
  return (
    <Switch>
      <Route path='/' exact component={SigninPage} />
      <Route path='/signin' component={SigninPage} />
      <Route path='/signup' component={SignupPage} />
      <Route path='/forgot-password' component={ForgotPasswordPage} />
      <Route path='/reset-password/:hash' component={ResetPasswordPage} />
      <Route path='/complete-profile' component={CompleteProfilePage} />
      <Route path='/confirm-email/:token' component={ConfimEmailPage} />
      <Redirect to='/' />
    </Switch>
  );
}
